import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const Storage = {
  getItem: async (item) => {
    if(Platform.OS === 'web'){
      return AsyncStorage.getItem(item);
    }else{
      try{
        const itemValue = await SecureStore.getItemAsync(item);
        return itemValue
      }catch(err){
        Storage.removeItem(item);
        return undefined;
      }
    }
  },
  setItem: (item, value) => {
    if (Platform.OS === 'web') {
      return AsyncStorage.setItem(item, value);
    } else {
      return SecureStore.setItemAsync(item, value);
    }
  },
  removeItem: (item) => {
    if (Platform.OS === 'web') {
      return AsyncStorage.removeItem(item);
    } else {
      return SecureStore.deleteItemAsync(item);
    }
  },
  clearAllItems: async () => {
    await Promise.all([
      Storage.removeItem('rtJWT'),
      Storage.removeItem('apiRequestTime'),
      Storage.removeItem('socialId'),
      Storage.removeItem('username'),
      Storage.removeItem('user'),
      Storage.removeItem('userId'),
      Storage.removeItem('password'),
      Storage.removeItem('useLocalAuthentication'),
      Storage.removeItem('rtDisputeFees'),
      Storage.removeItem('localAuthenticationMessage'),
      Storage.removeItem('localAuthenticationButtonText'),
      Storage.removeItem('localAuthenticationType'),
      Storage.removeItem('deepLink'),
    ]);
  }
}

export default Storage;